import React, { useState, useEffect, useCallback } from 'react';
import {
    Grid,
    Card,
    CardContent,
    makeStyles,
    Avatar,
    FormControlLabel,
    CardHeader,
    AppBar,
    Tabs,
    Tab,
    Button,
    Typography,
    TableBody,
    TableRow,
    TableCell,
    TextField,
} from '@material-ui/core';
import { useHistory, useParams } from 'react-router-dom';
import { getGrupos, getMembrosByGrupo } from '../../services/GruposApi';
import { getEventos, salvarEvento } from '../../services/EventoTempApi';
import { logout } from '../../services/AuthApi';
import toLower from 'lodash/toLower';
import startCase from 'lodash/startCase';
import InformationDialog from '../../components/InformationDialog';

const useStyles = makeStyles(theme => ({
    avatar: {},
    radiogroup: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    grid: {
        marginTop: theme.spacing(1),
    },
    cardHeader: {},
    cardContent: {},
    wrapperButton: {
        display: 'flex',
        alignContent: 'flex-end',
        justifyContent: 'flex-end',
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    label: {
        fontWeight: 'bold',
    },
    item: {
        marginLeft: theme.spacing(1),
        width: 80,
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Evento = () => {
    const [grupos, setGrupos] = useState([]);
    const { indexGrupo } = useParams();
    const [isCarregandoGrupo, setCarregandoGrupo] = useState(true);
    const [isCarregandoBibliaOn, setCarregandoBibliaOn] = useState(true);
    const [error, setError] = useState('');
    const classes = useStyles();
    const [grupoSelecionado, setGrupoSelecionado] = useState(false);
    const history = useHistory();
    const [membros, setMembros] = useState([]);
    const [eventoNota, setEventoNota] = useState(null);
    const [nbNota, setNbNota] = useState(0);
    const [mostrarMensagemSucesso, setMostrarMensagemSucesso] = useState(false);
    const [mostrarMensagemErro, setMostrarMensagemErro] = useState(false);

    async function fetchGrupos() {
        try {
            const grps = await (await getGrupos()).data;
            setGrupos(grps);
            setCarregandoGrupo(false);
        } catch (err) {
            setError(err);
        }
    }

    async function fetchEventos(idIgreja, idGrupoPequeno) {
        try {
            const response = await (await getEventos(idIgreja, idGrupoPequeno))
                .data;
            setCarregandoBibliaOn(false);
            return response;
        } catch (err) {
            return null;
        }
    }

    async function fetchMembros(idGrupoPequeno) {
        try {
            const response = await (await getMembrosByGrupo(idGrupoPequeno))
                .data;
            return response;
        } catch (err) {
            return null;
        }
    }

    async function carregarTab(grpSelecionado) {
        setGrupoSelecionado(grpSelecionado);
        if (grpSelecionado) {
            const membrosRemoto = await fetchMembros(
                grpSelecionado.idGrupoPequeno
            );
            setMembros(membrosRemoto);

            const eventoNotaAux = await fetchEventos(
                grpSelecionado.idGrupoPequeno
            );
            setEventoNota(eventoNotaAux);
            if (!!eventoNotaAux) {
                setNbNota(eventoNotaAux.nbNota);
            }
        }
    }

    useEffect(() => {
        if (isCarregandoGrupo && !error) {
            fetchGrupos();
        } else if (grupos.length === 0) {
            logout();
            history.push('/login');
            history.go();
        } else if (indexGrupo) {
            carregarTab(grupos[indexGrupo]);
        } else {
            carregarTab(grupos[0]);
        }
    }, [isCarregandoGrupo, error, indexGrupo]);

    const selecionarGrupo = (event, grpSelecionado) => {
        const idxGrupo = grupos.findIndex(
            g => g.idGrupoPequeno === grpSelecionado.idGrupoPequeno
        );
        if (idxGrupo !== -1) {
            history.push(`/evento/${idxGrupo}`);
        }
        carregarTab(grpSelecionado);
    };

    const handlerNota = useCallback(
        e => {
            setNbNota(e.target.value);
        },
        [nbNota]
    );

    const handleFecharMensagemDeSucesso = () => {
        setMostrarMensagemSucesso(false);
    };

    const handleFecharMensagemErro = () => {
        setMostrarMensagemErro(false);
    };

    const salvarNota = useCallback(async () => {
        try {
            await salvarEvento(eventoNota.id, nbNota);
            const eventoNotaAux = { ...eventoNota };
            eventoNotaAux.nbNota = nbNota;
            setEventoNota(eventoNotaAux);
            setMostrarMensagemSucesso(true);
        } catch (err) {
            setNbNota(eventoNota.nbNota);
            setMostrarMensagemErro(true);
        }
    }, [nbNota]);

    return !isCarregandoGrupo && !isCarregandoBibliaOn ? (
        <div className={classes.tab}>
            <AppBar position="static" style={{ zIndex: 1000 }}>
                <Tabs value={grupoSelecionado} onChange={selecionarGrupo}>
                    {grupos.map((grupo, i) => (
                        <Tab
                            key={grupo.idGrupoPequeno}
                            value={grupo}
                            label={`Grupo ${i + 1}`}
                            {...a11yProps(1)}
                        />
                    ))}
                </Tabs>
            </AppBar>

            <TabPanel value={grupoSelecionado} index={grupoSelecionado}>
                <Grid container spacing={2} className={classes.grid}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                <Card>
                                    <CardHeader
                                        avatar={
                                            <Avatar
                                                className={classes.avatar}
                                                src={
                                                    grupoSelecionado.txFotoLider1Url
                                                }
                                                alt={
                                                    grupoSelecionado.txMembroLider1
                                                }
                                            />
                                        }
                                        title={
                                            !!grupoSelecionado.txMembroLider2
                                                ? [
                                                      startCase(
                                                          toLower(
                                                              grupoSelecionado.txMembroLider1
                                                          )
                                                      ),
                                                      startCase(
                                                          toLower(
                                                              grupoSelecionado.txMembroLider2
                                                          )
                                                      ),
                                                  ].join(' e ')
                                                : startCase(
                                                      toLower(
                                                          grupoSelecionado.txMembroLider1
                                                      )
                                                  )
                                        }
                                    />
                                    <CardContent
                                        className={classes.cardContent}
                                    >
                                        {!!eventoNota ? (
                                            <FormControlLabel
                                                labelPlacement={'start'}
                                                label={
                                                    <Typography>
                                                        Convidados
                                                    </Typography>
                                                }
                                                className={classes.label}
                                                control={
                                                    <TextField
                                                        value={nbNota}
                                                        className={classes.item}
                                                        color="primary"
                                                        type="number"
                                                        onChange={value => {
                                                            handlerNota(value);
                                                        }}
                                                    />
                                                }
                                            />
                                        ) : (
                                            <Typography gutterBottom>
                                                {' '}
                                                Seu <b>GA</b> não possui horário
                                                definido para o{' '}
                                                <b>Dia Verde e Amarelo</b>. Por
                                                favor informe-nos o horário do
                                                seu GA através do e-mail{' '}
                                                <b>cadastro@nib.org.br</b>.
                                            </Typography>
                                        )}
                                    </CardContent>
                                    {!!eventoNota ? (
                                        <>
                                            <div
                                                className={
                                                    classes.wrapperButton
                                                }
                                            >
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={() => salvarNota()}
                                                    className={classes.button}
                                                >
                                                    Salvar
                                                </Button>
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <TableBody>
                                        {membros.map(row => (
                                            <TableRow hover key={row.idMembro}>
                                                <TableCell>
                                                    <Avatar
                                                        className={
                                                            classes.large
                                                        }
                                                        src={row.txFotoUrl}
                                                    ></Avatar>
                                                </TableCell>
                                                <TableCell
                                                    className={
                                                        classes.tableCellNome
                                                    }
                                                    component="th"
                                                    scope="row"
                                                    align="left"
                                                >
                                                    {row.txMembro}
                                                </TableCell>{' '}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </TabPanel>
            <InformationDialog
                titulo={'Dia Verde e Amarelo'}
                handleClose={handleFecharMensagemDeSucesso}
                open={mostrarMensagemSucesso}
            >
                Dados registrados com sucesso!
            </InformationDialog>
            <InformationDialog
                titulo={'Dia Verde e Amarelo'}
                handleClose={handleFecharMensagemErro}
                open={mostrarMensagemErro}
            >
                Falha ao registrar os dados. Tente novamente. Se precisar de
                ajuda entre em contato via Whatsapp pelo número{' '}
                <b>99205-0094</b> ou envie um e-mail para{' '}
                <b>cadastro@nib.org.br</b> .
            </InformationDialog>
        </div>
    ) : (
        <div>Carregando...</div>
    );
};

export default Evento;
